

















import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import PolygonViewer from "@/components/wrappedGoogleMaps/PolygonViewer.vue";
import geojson from '@/components/wrappedGoogleMaps/geo.json';
import * as resultsService from "@/services/results/index";
import {FarmAnalysisResult} from "@/api/results/types";

@Component({
  name: 'InteractiveMapController',
  components: {
    PolygonViewer,
  },
})
export default class InteractiveMapController extends Vue {

  @Prop(String) private url?: string;

  @Prop(String) private farmAnalysisUuid?: string; 

  @Prop(String) private downloadFileName?: string;

  @PropSync('selected', { type: Array, default: () => [] }) private selectedCrops!: string[];

  @Prop({type: Object, default: () => null }) private fallback!: GeoJSON.GeoJSON | null;

  @Prop({ type: String, default: "base-style" })
  private mapClass!: string;
  
  @Prop({ type: Boolean, default: false})
  private showMapBiomasIcon!: boolean;

  @Prop(Array)
  private extraPolygons?: Object[];

  private polygon?: GeoJSON.GeoJSON | null = null;

  @Watch('url')
  private async updateGeojson() {
    await this.updatePolygon();
  }

  public showPlots(event: any) {
    (this.$refs.polygonViewer as any).showPlots(event);
  }

  @Watch('fallback')
  private async updateFallback() {
    await this.updatePolygon();
  }

  private downloadAsGeoJson(polygon: GeoJSON.GeoJSON | null) {
    if (!!polygon) {
      const blob = new Blob([JSON.stringify(polygon)], { type: 'application/geo+json; encoding=utf8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = this.downloadFileName!;
      link.href = url;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  }

  private async updatePolygon() {
    if (!!this.url) {
      try {
        this.polygon = (await resultsService.downloadGeoJson(this.url));
      } catch {}
    } else {
      this.polygon = this.fallback;
    }
  }

  private async mounted() {
    await this.updatePolygon();
  }
}
